import styled from 'styled-components';

// 메인 컨테이너
export const PopupContainer = styled.div`
  padding: 20px;
  display: flex;
  gap: 30px;
  height: 100%;
  width: 100%;
  min-width: 0;
`;

export const LeftSection = styled.div`
  width: 319px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
`;

export const RightSection = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const TopSection = styled.div`
  display: flex;
  gap: 30px;
  margin-bottom: 30px;
  min-width: 0;
`;

// 왼쪽 Lots 영역 스타일
export const LotsTitle = styled.h2`
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin: 0 0 20px 0;
  text-align: left;
`;

export const ProgressContainer = styled.div`
  margin-bottom: 20px;
  background: #f4f4f4;
  border-radius: 8px;
  padding: 16px;
`;

export const ProgressLabel = styled.div`
  font-size: 16px;
  color: #666;
  margin-bottom: 8px;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background: #e0e0e0;
  border-radius: 4px;
  overflow: hidden;
`;

export const ProgressFill = styled.div<{ percentage: number }>`
  height: 100%;
  background: linear-gradient(90deg, #667eea 0%, #52c41a 100%);
  width: ${props => props.percentage}%;
  transition: width 0.3s ease;
`;

export const LotsContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-height: 600px;
  overflow-y: auto;
  
  /* 스크롤바 스타일링 */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

export const LotCard = styled.div<{ isSelected: boolean; status: string }>`
  border: ${props => {
    if (props.isSelected) return '2px solid #4F46E5';
    return '1px solid #f3f4f6';
  }};
  border-left: ${props => {
    if (props.isSelected) return '4px solid #4F46E5';
    if (props.status === 'ONGOING') return '4px solid #10B981';
    return 'none';
  }};
  border-bottom: 1px solid #f3f4f6;
  border-radius: 8px;
  padding: 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: ${props => {
    if (props.isSelected) return '#EEF2FF';
    if (props.status === 'ONGOING') return '#F0FDF4';
    return 'white';
  }};
  opacity: ${props => props.status === 'COMPLETED' ? 0.5 : 1};
  display: flex;
  gap: 12px;
  box-shadow: ${props => {
    if (props.isSelected) return '0 4px 12px rgba(79, 70, 229, 0.2)';
    if (props.status === 'ONGOING') return '0 2px 6px rgba(16, 185, 129, 0.15)';
    return 'none';
  }};
  transform: ${props => props.isSelected ? 'translateY(-1px)' : 'none'};
  
  &:hover {
    box-shadow: ${props => {
      if (props.status === 'COMPLETED') return 'none';
      if (props.isSelected) return '0 6px 16px rgba(79, 70, 229, 0.25)';
      if (props.status === 'ONGOING') return '0 4px 8px rgba(16, 185, 129, 0.2)';
      return '0 2px 4px rgba(0, 0, 0, 0.08)';
    }};
  }
`;

export const LotCardImage = styled.div`
  width: 60px;
  height: 60px;
  background: #f5f5f5;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 10px;
  text-align: center;
  flex-shrink: 0;
`;

export const LotCardContent = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
`;

export const LotCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  min-width: 0;
`;

export const LotCardChip = styled.div`
  background: #2f3b9c;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
`;

export const LotCardStatus = styled.span<{ status: string }>`
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 500;
  background: ${props => {
    switch (props.status) {
      case 'ONGOING': return '#52c41a';
      case 'WAITING': return '#faad14';
      case 'COMPLETED': return '#d9d9d9';
      case 'SCHEDULED': return '#1890ff'; // 진행예정 - 파란색
      default: return '#d9d9d9';
    }
  }};
  color: white;
`;

export const LotCardName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
`;

export const LotCardPrice = styled.div`
  font-size: 13px;
  color: #666;
  margin-bottom: 2px;
  text-align: left;
`;

export const LotCardTime = styled.div`
  font-size: 12px;
  color: #999;
  text-align: left;
`;

// 현재 로트 정보 영역 스타일
export const ArtworkInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ArtworkContent = styled.div`
  display: block;
`;

export const ArtworkDetails = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 120px;
  min-width: 0;
`;

export const LotHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 20px;
  min-width: 0;
`;

export const ImageAndNameColumn = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LotNameLabel = styled.div`
  color: #888;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 4px;
  text-align: left;
`;

export const LotNameValue = styled.div`
  color: #333;
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
`;

export const AuctionEndLabel = styled.div`
  color: #333;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 4px;
  text-align: left;
`;

export const CountdownTimer = styled.div`
  color: #333;
  font-size: 18px;
  font-weight: 500;
  text-align: left;
`;

export const ImageAndNameRow = styled.div`
  display: flex;
  gap: 20px;
  align-items: flex-start;
  min-width: 0;
`;

export const LotChip = styled.div`
  display: inline-block;
  background: #2f3b9c;
  color: white;
  padding: 4px 12px;
  border-radius: 16px;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 8px;
  flex-shrink: 0;
`;

export const ArtworkTitle = styled.div`
  flex: 1;
  min-width: 0;
  font-size: 24px;
  font-weight: 700;
  color: #333;
  margin: 0;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ArtworkImage = styled.div`
  width: 120px;
  height: 120px;
  background: #f5f5f5;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 14px;
  border: 1px solid #e0e0e0;
`;

// 입찰 금액 정보 영역 스타일
export const BidAmountInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const SectionTitle = styled.h3`
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin: 0;
  text-align: left;
`;

export const PriceSection = styled.div`
  margin-bottom: 20px;
`;

export const PriceRow = styled.div`
  display: flex;
  gap: 30px;
`;

export const PriceColumn = styled.div`
  flex: 1;
`;

export const PriceLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
  text-align: left;
`;

export const CurrentPriceValue = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: #bb3f3f;
  text-align: left;
`;

export const StartPriceValue = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: #333;
  text-align: left;
`;

// 입찰내역 영역 스타일
export const BidHistorySection = styled.div`
  margin-top: 20px;
`;

export const BidHistoryHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

// PreBid 정보 표시 영역
export const PreBidInfoSection = styled.div`
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 6px;
  padding: 12px 16px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const PreBidLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #495057;
`;

export const PreBidInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const PreBidUser = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #212529;
`;

export const PreBidPrice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
`;

export const PreBidPriceKRW = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #dc3545;
`;

export const PreBidPriceUSD = styled.span`
  font-size: 12px;
  color: #6c757d;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;

export const ActionButton = styled.button<{ variant?: 'excel' | 'default' }>`
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  background: ${props => props.variant === 'excel' ? '#51815a' : '#393c53'};
  color: white;
  transition: all 0.2s ease;
  
  &:hover:not(:disabled) {
    opacity: 0.8;
  }
  
  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed; /* 고정 레이아웃으로 컬럼 너비 제어 */
  
  th, td {
    border: 1px solid #e0e0e0;
    padding: 8px 12px;
    text-align: center;
    font-size: 13px;
    overflow: visible; /* 툴팁이 보이도록 변경 */
    text-overflow: ellipsis;
    white-space: nowrap;
    position: relative; /* 툴팁 포지셔닝을 위해 추가 */
  }
  
  /* 각 컬럼 너비 지정 */
  th:nth-child(1), td:nth-child(1) { width: 5%; }   /* No */
  th:nth-child(2), td:nth-child(2) { width: 14%; }  /* 입찰일시 (축소) */
  th:nth-child(3), td:nth-child(3) { width: 10%; }  /* 입찰자 */
  th:nth-child(4), td:nth-child(4) { width: 12%; }  /* 현장번호 (확대) */
  th:nth-child(5), td:nth-child(5) { width: 8%; }   /* 국가 */
  th:nth-child(6), td:nth-child(6) { width: 15%; }  /* 입찰금액(KRW) */
  th:nth-child(7), td:nth-child(7) { width: 15%; }  /* 입찰금액(USD) */
  th:nth-child(8), td:nth-child(8) { width: 10%; }  /* 연락처 */
  th:nth-child(9), td:nth-child(9) { width: 15%; }  /* 이메일 */
  th:nth-child(10), td:nth-child(10) { width: 8%; } /* 입찰제한 */
  
  th {
    background: #f8f9fa;
    font-weight: 600;
    color: #333;
  }
  
  td {
    color: #666;
  }
  
  tbody tr.clickable {
    cursor: pointer;
    transition: background-color 0.2s ease;
    
    &:hover {
      background: #f0f0f0;
    }
  }
  
  tbody tr.non-clickable {
    cursor: default;
  }
  
  tr:nth-child(even) {
    background: #fafafa;
    
    &.clickable:hover {
      background: #f0f0f0;
    }
  }
`;

// 툴팁이 있는 셀 스타일
export const TooltipCell = styled.div`
  position: relative;
  width: 100%;
  
  & > span {
    display: block;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

// 툴팁 스타일
export const Tooltip = styled.div`
  position: fixed; /* absolute에서 fixed로 변경하여 화면에 고정 */
  background: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 6px 14px;
  border-radius: 6px;
  font-size: 13px;
  z-index: 10000; /* 더 높은 z-index */
  max-width: 400px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  pointer-events: auto; /* 복사 버튼 클릭을 위해 변경 */
  
  /* 툴팁과 셀 사이의 연결 영역 (마우스 이동 편의성) */
  &::before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    width: 20px;
    height: 20px;
    background: transparent;
  }
  
  /* 툴팁 내부 플렉스 레이아웃 */
  & > div {
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
  }
  
  /* 툴팁 내부 텍스트 */
  & > div > span {
    white-space: nowrap;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

// 복사 아이콘 스타일 (툴팁 내부용)
export const CopyIcon = styled.button`
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  cursor: pointer;
  font-size: 12px;
  padding: 4px 6px;
  border-radius: 3px;
  color: white;
  transition: all 0.2s ease;
  flex-shrink: 0;
  
  &:hover {
    background: rgba(255, 255, 255, 0.3);
    border-color: rgba(255, 255, 255, 0.5);
  }
  
  &:active {
    transform: scale(0.95);
  }
`;

export const ToggleSwitch = styled.div`
  position: relative;
  width: 50px;
  height: 24px;
  background: ${props => props.className?.includes('active') ? '#52c41a' : '#d9d9d9'};
  border-radius: 12px;
  cursor: pointer;
  transition: background 0.3s ease;
  
  &::before {
    content: '';
    position: absolute;
    top: 2px;
    left: ${props => props.className?.includes('active') ? '26px' : '2px'};
    width: 20px;
    height: 20px;
    background: white;
    border-radius: 50%;
    transition: left 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }
`;

// 모달 관련 스타일
export const ModalButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  
  & > * {
    flex: 1;
  }
`;
